import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ConfirmationService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { lastValueFrom } from "rxjs";

@Component({
  selector: "app-popup-dialog",
  standalone: true,
  imports: [CommonModule, ConfirmDialogModule, ButtonModule],
  templateUrl: "./popup-dialog.component.html",
  styleUrls: ["./popup-dialog.component.scss"],
  providers: [ConfirmationService],
})
export class PopupDialogComponent implements OnInit {
  @Output() dialogEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() visibleDialog!: boolean;
  @Input() saveMessage: any = {};
  @Input() acceptLabel!: string;
  @Input() rejectLabel!: string;
  @Input() showRejectButton = true;

  constructor(
    private readonly confirmationService: ConfirmationService,
    private readonly translate: TranslateService
  ) {}

  async ngOnInit() {
    const translations = await lastValueFrom(this.translate.get(["StandardPopup.Yes", "StandardPopup.No"]));

    this.acceptLabel = this.acceptLabel ?? translations["StandardPopup.Yes"];
    this.rejectLabel = this.rejectLabel ?? translations["StandardPopup.No"];

    this.confirmCloseDialog(this.saveMessage.header, this.saveMessage.message);
  }

  confirmCloseDialog(header: string, message: string) {
    this.confirmationService.confirm({
      header: header,
      message: message,
      accept: () => {
        this.dialogEmitter.emit(true);
        this.visibleDialog = false;
      },
      reject: () => {
        if (this.showRejectButton) {
          this.dialogEmitter.emit(false);
        }
        this.visibleDialog = false;
      },
    });
  }
}
